/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
import { AxiosResponse } from 'axios';
import { apiagencianoticiaExterna } from '../api';

export const getGovernorData = async (): Promise<AxiosResponse> =>
  apiagencianoticiaExterna.get('/wp-json/wp/v2/pages/1385');
